import { Component, OnInit, Inject } from '@angular/core';
import { FontawesomeService } from '@app/services/fontawesome.service';
import { PlatformService } from '@app/services';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { IcodominoService } from '@app/services/icodomino.service';

@Component({
    selector: 'app-icons-selector-dialog',
    templateUrl: './icons-selector-dialog.component.html',
    styleUrls: ['./icons-selector-dialog.component.scss'],
    standalone: false
})
export class IconsSelectorDialogComponent implements OnInit {

  iconsFontawesome: [];
  iconsDomino: {};
  selectedValueDomino: string;
  selectedValueFontawesome: string;
  typeIcon: string;
  loadMore = false;
  nbShowIcons = 152;
  termFontawesome: string;
  indexTab: number;

  searchTermDomino = new UntypedFormControl();
  searchTermDomino$: Observable<string> = this.searchTermDomino.valueChanges;
  searchTermFontawesome = new UntypedFormControl();
  searchTermFontawesome$: Observable<string> = this.searchTermFontawesome.valueChanges;

  constructor(
    private fontawesomeService: FontawesomeService,
    public platformService: PlatformService,
    private icodominoService: IcodominoService,
    @Inject(MAT_DIALOG_DATA) private data
  ) { }

  ngOnInit() {
    this.fontawesomeService.getAllIcons().subscribe(res => {
      this.iconsFontawesome = res;
    })

    this.icodominoService.getAllIconNames().subscribe(res => {
      this.iconsDomino = res;
    });

    this.searchTermFontawesome$.pipe(
      debounceTime(200),
      switchMap(term => {
        this.termFontawesome = term;
        return this.fontawesomeService.search(term);
      })
    ).subscribe(listIcons => {
      (this.termFontawesome === '' || this.termFontawesome === undefined) ? this.loadMore = false : this.loadMore = true;
      this.iconsFontawesome = listIcons;
    })

    this.searchTermDomino$.pipe(
      debounceTime(200),
      switchMap(term => this.icodominoService.search(term))
    ).subscribe(listIcons => {
      this.iconsDomino = listIcons;
    })

    if(this.data.data.iconFontawesome){
      if(this.data.data.typeIcon){
        this.selectedValueFontawesome = this.data.data.typeIcon +' fa-'+ this.data.data.iconFontawesome;
      } else {
        this.selectedValueFontawesome = 'fas fa-' + this.data.data.iconFontawesome;
      }
    } else {
      this.selectedValueDomino = this.data.data.iconDomino;
    }

    if(this.data.data.typeIcon){
      this.typeIcon = this.data.data.typeIcon;
    }

  }

  validIcon() {
    if(this.selectedValueFontawesome){
      this.data.data.iconFontawesome = this.selectedValueFontawesome.split(' ').pop().split('fa-').pop();
      this.data.data.typeIcon = this.selectedValueFontawesome.split(' ').shift();
    } else {
      this.data.data.iconDomino = this.selectedValueDomino;
      this.data.data.typeIcon = "do";
    }
  }

  removeSelect() {
    this.selectedValueFontawesome = null;
    this.selectedValueDomino = null;
    this.data.data.iconFontawesome = null;
    this.data.data.iconDomino = null;
    this.data.data.typeIcon = null;
    this.typeIcon = null;
  }

  loadMoreIcons() {
    this.nbShowIcons += 153;
    this.loadMore = this.iconsFontawesome.length >= this.nbShowIcons ? false : true;
  }

  onTabChanged(event) {
    this.nbShowIcons = 152;
    (this.termFontawesome === '' || this.termFontawesome === undefined) ? this.loadMore = false : this.loadMore = true;
    this.indexTab = event.index;
  }

  radioDominoChange(event) {
    this.selectedValueFontawesome = null;
    this.data.data.iconFontawesome = null;
    this.typeIcon = null;
  }
  radioFontawesomeChange(event) {
    this.selectedValueDomino = null;
    this.data.data.iconDomino = null;
    this.typeIcon = null;
  }
}
